var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (model) {
buf.push("<span class=\"text-bold text-gray-dark\">" + (jade.escape(null == (jade_interp = model.name) ? "" : jade_interp)) + "&nbsp;&nbsp;");
if (!( model.locked))
{
buf.push("<a type=\"button\" class=\"close\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Remove</span></a>");
}
buf.push("</span>");}.call(this,"model" in locals_for_with?locals_for_with.model:typeof model!=="undefined"?model:undefined));;return buf.join("");
}